import { fetchAPI } from 'api';
import { InitiateExternalRefundResponse } from 'pages/api';

export const initiateRefund = (
  orderId: string,
  refundDestinationAddress: string
) => {
  return fetchAPI<InitiateExternalRefundResponse>(
    `v1/order/${orderId}/initiate-refund`,
    {
      method: 'POST',
      body: {
        refundDestinationAddress,
      },
    }
  );
};
